import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility/utility";

const initialState = {
  loading: false,
  errors: [],
  interestedUsers: [],
};

const interestedUsersStart = (state) =>
  updateObject(state, { loading: true, errors: [] });

const interestedUsersFail = (state, action) =>
  updateObject(state, { errors: action.error, loading: false });

const interestedUsers = (state, action) =>
  updateObject(state, { interestedUsers: action.response, loading: false });

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INTERESTED_USERS_START:
      return interestedUsersStart(state);
    case actionTypes.INTERESTED_USERS_FAIL:
      return interestedUsersFail(state, action);
    case actionTypes.GET_ALL_INTERESTED_USERS_SUCCESS:
      return interestedUsers(state, action);
    default:
      return state;
  }
};

export default reducer;
